//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import common from "../../api/common";
export default {
    data() {
        return {
            doctorid: this.$route.query.doctorId,
            hospitaid: this.$route.query.hospitaid,
            patientid: '',
            // doctorid: '2019053011085018055ad96b46f5b',
            // hospitaid: '20190530111809555fcbeebe3441d',
            photourl: '',//医院图片
            photourl: '',//医院图片
            intro: '',//介绍
            type: '',//医生专家
            headphoto: '',
            doctorname: '',//医生姓名
            duties: '',//医生职称
            hospitaname: '',//医院名称
            thagainprice: '',//咨询价格
            diagnosecount: '',//问诊订单数
            medicinecount: '',//复诊订单数
            remark: '',
            doctorList: [],
            isShow: false,
            slid: '展开',
        }
    },
    methods: {
        //获取机构医生信息
        getDoctorInfo(){
            let params = {
                doctorid: this.doctorid,
                hospitaid: this.hospitaid,
            };
            this.$doRequest("/api/org/h5doctorinfo", params, res=>{
                this.photourl = res.photourl;
                this.intro = res.intro;
                this.type = res.type;
                this.headphoto = res.headphoto;
                this.doctorname = res.doctorname;
                this.duties = res.duties;
                this.hospitaname = res.hospitaname;
                this.thagainprice = res.thagainprice;
                this.diagnosecount = res.diagnosecount;
                this.medicinecount = res.medicinecount;
                this.remark = res.remark;
                this.$store.state.sun.price = this.thagainprice;
            });
        },
        //获取当前机构医生列表
        getDoctorList(){
            let params = {
                pageLength: '1000',
                pagination: '1',
                condition: {
                    doctorid: this.doctorid,
                    hospitaid: this.hospitaid,
                    patientid: this.patientid
                }
            };
            this.$doRequest("/api/org/h5doctorlist", params, res=>{
                res.parameters.rows.forEach(item => {
                    if(item.doctorskill && item.doctorskill != undefined && item.doctorskill != null && item.doctorskill != ''){
                        item.doctorskill = item.doctorskill.split(',');
                    }
                });
                this.doctorList = res.parameters.rows;
            });
        },
        //展开/关闭
        show(){
            if(this.isShow){
                this.slid = '展开';
                this.isShow = false;
            }else{
                this.slid = '收起';
                this.isShow = true;
            }
        },
        //
        gotoinfo(){
            this.$router.push({ path: "/buyServiceDetails" });
        },
        goPath(row){
            this.$store.state.AllOfValue.doctorId = row.id;
            this.$router.push({ path: "/doctorDetails", query: { state: 'g8t7r3'} });
        },
        query(){
            this.patientid = this.$store.state.userInfo.id;
            this.getDoctorInfo();
            this.getDoctorList();
        }
    },
    //生命周期之创建完成
    created: function() {
        this.$store.state.AllOfValue.doctorId = this.$route.query.doctorId;
        this.$isLogin(window.location.search.substr(1), this.query);
    },
};



// WEBPACK FOOTER //
// ./src/views/orgDoctorDetails/index.vue